import { Inject, Injectable } from '@angular/core';
import { Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppConfigService } from '../../app-config.service';
import { combineLatest, Observable, map } from 'rxjs';
import { AccessService, StubAccessService } from '../access';
import { Views } from '../access/interface';
import { TRAINING_RESOURCES_PAGE_ROUTES } from '../../training-resources/training-resources-routing.module';

const GeneralSalespeoplePages = [
  '/st/leaderboard',
  '/sales/leaderboard',
  `/training-resources/${TRAINING_RESOURCES_PAGE_ROUTES.PRODUCTS_LIST}`,
  `/training-resources/${TRAINING_RESOURCES_PAGE_ROUTES.PRODUCT}`,
];

@Injectable({ providedIn: 'root' })
export class SalespeopleGuard {
  constructor(
    @Inject(StubAccessService) private access: AccessService,
    private readonly configService: AppConfigService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const hasSalespersonAccess$ = this.access
      .hasAccessToViews([Views.salespersonAll])
      .pipe(map((response) => response.get(Views.salespersonAll) ?? false));
    const partnerAccessCheck$ = this.configService.config$.pipe(map((config) => config.userCanAccessSales ?? false));
    if (GeneralSalespeoplePages.includes(state.url)) {
      return combineLatest([hasSalespersonAccess$, partnerAccessCheck$]).pipe(
        map(([hasSalesperson, hasPartner]) => hasSalesperson || hasPartner),
        map((hasAccess) => hasAccess ?? this.router.createUrlTree(['/access-denied'])),
      );
    }
    return partnerAccessCheck$.pipe(map((hasAccess) => hasAccess ?? this.router.createUrlTree(['/access-denied'])));
  }
}
